import _ from 'lodash';

import { parse as parseQuery, stringify } from 'query-string';

import { withoutEmptyValues } from './helpers';

// safeStringify :: Object -> String
// transforms an object representation of query params to a string, while stripping any empty values
// i.e. { category: 'travel', credit_score: undefined } --> "category=travel"
export const safeStringify = _.pipe(withoutEmptyValues, stringify);

// we should remove any input that's not an encoded space (%20), alphanumeric, or some special characters (- _ ? & =)
const sanitizeQueryString = (queryString) =>
  queryString
    ? queryString.replace(/%20/g, ' ').replace(/[^?=&-\w\s]/g, '')
    : queryString;

export const getQueryParams = _.pipe(
  _.prop('location.search'),
  sanitizeQueryString,
  parseQuery,
  withoutEmptyValues
);

// handles client-side dependency changes via query params, i.e. for filters
export const updateParams = (params, history) => () => {
  // update query params
  history.replace({
    search: safeStringify(params),
  });
};
